var React = require('react');

function Close (props) {
    return React.createElement("svg",props,[React.createElement("line",{"x1":"0.697228","y1":"10.5957","x2":"10.5967","y2":"0.696171","stroke":"currentColor","key":0}),React.createElement("line",{"x1":"0.353553","y1":"0.646447","x2":"10.253","y2":"10.5459","stroke":"currentColor","key":1})]);
}

Close.defaultProps = {"viewBox":"0 0 11 11 ","width":"11","height":"11"};

module.exports = Close;

Close.default = Close;
